import React from "react";
import ImageCard from "../../common/ImageCard";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

import app from "../../../resources/school/app.png";
import classImg from "../../../resources/school/class.png";
import costume from "../../../resources/events/costume.png";

const Features = () => {
  const { t } = useTranslation("home");

  return (
    <div className="text-center my-8">
      <div className="text-2xl text-emerald-400 font-bold mb-8">
        {t("features.title")}
      </div>

      <div className="md:w-3/4 md:mx-auto">
        <Row>
          <>
            <ImageCard
              src={classImg}
              children={
                <>
                  {t("features.card1.line1")} <br />
                  {t("features.card1.line2")}
                </>
              }
            />

            <ImageCard
              src={app}
              children={
                <>
                  {t("features.card2.line1")} <br />
                  {t("features.card2.line2")}
                </>
              }
            />

            <ImageCard
              src={costume}
              children={
                <>
                  {t("features.card3.line1")} <br />
                  {t("features.card3.line2")}
                </>
              }
            />
          </>
        </Row>
      </div>
    </div>
  );
};

export default Features;
